import { isAxiosError } from 'axios'
import useSWR, { type SWRConfiguration, type SWRResponse } from 'swr'

import { Configuration, DefaultApi, ErrorResponse } from '@infura/packages.api'

import { _GetTypedParams, _GetTypedReturn } from 'lib/api/utils'

export const api = new DefaultApi(
  new Configuration({
    basePath: '/api'
  })
)

export async function apiFetcher([method, ...args]) {
  try {
    return (await api[method](...args)).data
  } catch (e: any) {
    if (isAxiosError(e)) {
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      throw e.response.data
    }
    throw e
  }
}

export function useApi<TMethodName extends keyof DefaultApi, TMethod extends DefaultApi[TMethodName]>(
  keys: readonly [TMethodName, ..._GetTypedParams<TMethod>] | null,
  config?: Partial<SWRConfiguration>
): SWRResponse<_GetTypedReturn<TMethod>, ErrorResponse> {
  return useSWR(keys, apiFetcher, config)
}
